// Server epoch milliseconds anchored to a monotonic clock, so changing the PC
// clock after calibration cannot move a market into another trading session.
let serverEpoch = null, calibratedAt = 0

export function syncServerTime(timestamp, requestedAt) {
  const value = Number(timestamp)
  if (!Number.isFinite(value) || value <= 0) return
  const receivedAt = performance.now()
  serverEpoch = value + (Number.isFinite(requestedAt) ? Math.max(0, receivedAt - requestedAt) / 2 : 0)
  calibratedAt = receivedAt
}

export function serverNow() {
  return new Date(serverEpoch == null ? Date.now() : serverEpoch + performance.now() - calibratedAt)
}

// Market display/quote schedule only. Platform order permissions and blackout
// dates are deliberately not used as an exchange trading calendar.
export function marketSession(market, now = serverNow()) {
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: market === 'us' ? 'America/New_York' : market === 'hk' ? 'Asia/Hong_Kong' : 'Asia/Shanghai',
    weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(now).map(part => [part.type, part.value]))
  if (['Sat', 'Sun'].includes(parts.weekday)) return '休市'
  const minute = Number(parts.hour) * 60 + Number(parts.minute)
  if (minute < 570) return '未开盘'
  if (minute >= (market === 'cn' ? 900 : 960)) return '已收盘'
  if (market !== 'us' && minute >= (market === 'cn' ? 690 : 720) && minute < 780) return '午间休市'
  return '交易中'
}
